import React from 'react';
import './steps.scss';
import cx from 'classnames';

const Steps = (props) => {
  const { activeItem } = props;

  return (
    <div className="curren-step">
      <span className="title">Step:</span>
      <span className={cx('step step-1', { active: activeItem === 1 })}>1</span>
      <span className={cx('step step-2', { active: activeItem === 2 })}>2</span>
      <span className={cx('step step-3', { active: activeItem === 3 })}>3</span>
    </div>
  );
};

export default Steps;
